export const determinarTipoComprobante = (
    condicionFiscalCliente,
    setTipoComprobante
) => {
    const puntoVenta = JSON.parse(sessionStorage.getItem('ptoventa') || '{}');
    const condicionFiscalComercio = puntoVenta?.datoFiscal?.condicionFiscal?.id || 0;

    if (condicionFiscalComercio === 1) {
        switch (condicionFiscalCliente) {
            case 1:
                setTipoComprobante(1) // Factura A
                break;
            case 5:
            case 6:
                setTipoComprobante(2) // Factura B
                break;
            default:
                setTipoComprobante(3) // Factura C por defecto
                break;
        }
    } else {
        // Para cualquier otra condición fiscal del comercio siempre Factura C
        setTipoComprobante(3)
    }
}
